var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EC3F7",
    fillRule: "evenodd",
    d: "M66 0c36.393 0 66 29.607 66 66s-29.607 66-66 66S0 102.393 0 66 29.607 0 66 0zm0 6C32.916 6 6 32.916 6 66s26.916 60 60 60 60-26.916 60-60S99.084 6 66 6zm33.092 30.88l4.248 4.24L50.9 93.672l-4.248-4.236 52.44-52.556zM32.29 65.3l12.92 15.3-4.583 3.873-12.918-15.3 4.58-3.873z"
  })));
}

export default SvgTick;